export default {
      id: "ic_traduction-usage",
      viewBox: "0 0 50 50",
      url: "../dist/images/" + "sprite.svg#ic_traduction-usage",
      toString: function () {
        return this.url;
      }
    }